import { Component, Input, OnInit } from "@angular/core";
import { PriceEditarValorComponent } from "./price-editar-valor.component";
import { MatDialog } from "@angular/material/dialog";
import { ToastrComponent } from "../util/toastr/toastr.component";
import { Subject, switchMap } from "rxjs";
import { PriceResumo } from "src/app/models/price-resumo.model";
import { PriceParamProjeto } from "src/app/models/price-param-projeto.model";
import { CalculoService } from "src/app/services/calculo.service";
import { PriceModelService } from "src/app/services/price-resumo.service";
import { PriceParamProjetoService } from "src/app/services/price-param-projeto.service";
import { UtilService } from "src/app/services/util.service";
import { EstimativaService } from "src/app/services/estimativa.service";
import { Misc } from "../util/misc";
import { PriceEditaValorAdotadoComponent } from "./price-edita-valor-adotado/price-edita-valor-adotado.component";
import { ActivatedRoute } from "@angular/router";
import { FormBuilder, FormGroup } from "@angular/forms";
import * as constants from "src/app/models/constants/constants";
import { result } from "lodash";
import { EquipeService } from "src/app/services/equipe.service";
import { forkJoin } from "rxjs";
import { Equipe } from "src/app/models/equipe.model";
import { PriceParamService } from "src/app/services/price-param.service";

@Component({
  selector: "app-price-resumo",
  templateUrl: "./price-resumo.component.html",
  styleUrls: ["./price-resumo.component.scss"],
})
export class PriceResumoComponent implements OnInit {
  @Input() estimativaId: number;
  @Input() somenteLeitura: boolean;
  @Input() resetFormSubject: Subject<boolean> = new Subject<boolean>();
  @Input() hiddenResume: boolean;
  @Input() estimativaTipoId: number;

  tipoDelivery: boolean;
  tipoProjeto: boolean;

  priceResumo: PriceResumo = new PriceResumo();
  priceOriginal: PriceResumo = new PriceResumo();
  priceSimulacao: number;
  loading: boolean = true;
  isAdmin = false;
  isDelivery = false;
  estimativaTipo = 0;

  idOriginal: number;
  idOriginalDupli: number;

  exibeAdotado = false;

  mostraAdotado = false;
  adotado: any;
  sugerido: any;

  params: Array<PriceParamProjeto>;
  paramsDefault: Array<PriceParamProjeto>;
  priceModel: any;
  pricingForm: FormGroup;

  estimativaDelivery: any;
  estimativaProjeto: any;
  estimativaBodyshop: any;
  perfilTipo: any;

  equipes: any;
  margemLiquida: any;

  maoDeObraOriginal: any;

  liderancaAdotado = "0.00";
  liderancaSugerido = "0.00";

  valoresDigitados = {
    maoDeObraDireta: 0,
    parceiros: 0,
    custosAdicionais: 0,
    quantidadeHoras: 0,
    custoHoraMedio: 0,
  };

  totais = {
    maoDeObraDireta: 0,
    parceiros: 0,
    custosAdicionais: 0,
    quantidadeHoras: 0,
    custoHoraMedio: 0,
  };

  percentuais = {
    maoDeObraDireta: 0,
    parceiros: 0,
    custosAdicionais: 0,
    quantidadeHoras: 0,
    custoHoraMedio: 0,
  };

  currencyOptions: any = {
    prefix: "",
    thousands: ".",
    decimal: ",",
    precision: 10,
  };

  currencyOptionsDefault: any = {
    prefix: "",
    thousands: ".",
    decimal: ",",
  };

  percentOptions = {
    prefix: "",
    thousands: ".",
    decimal: ",",
    precision: 2,
    allowNegative: false,
  };

  private readonly PROJ = { BONIFICACAO: 2, MARGEM: 5, LIDERANCA: 34 } as const;
  private readonly BS = { BONIFICACAO: 22, LIDERANCA: 35 } as const;

  minPct: Record<number, number> = {};

  bodyShopBonifPerfil?: number | boolean;
  BodyShopBonifPerfil?: number | boolean;

  constructor(
    private calculoService: CalculoService,
    private dialog: MatDialog,
    private priceModelService: PriceModelService,
    private priceParamProjetoService: PriceParamProjetoService,
    public utilService: UtilService,
    private misc: Misc,
    private toastr: ToastrComponent,
    private estimativaService: EstimativaService,
    private activatedRouter: ActivatedRoute,
    private fb: FormBuilder,
    private equipeService: EquipeService,
    private priceParamService: PriceParamService,
  ) {
    this.pricingForm = this.fb.group({
      pricingFromStaffPlan: [false],
    });
  }

  ngOnInit() {
    const estimativaId = this.activatedRouter.snapshot.params.id;

    this.estimativaService.verificarParamsProject(estimativaId).subscribe({
      next: (success) => { },
      error: (error) => { },
    });

    this.isAdmin = this.utilService.isAdmin();
    this.isDelivery = this.utilService.isDelivery();

    this.estimativaProjeto =
      constants.TipoEstimativaConstants.ID_TIPO_ESTIMATIVA_PROJETO;
    this.estimativaDelivery =
      constants.TipoEstimativaConstants.ID_TIPO_ESTIMATIVA_DELIVERY;
    this.estimativaBodyshop =
      constants.TipoEstimativaConstants.ID_TIPO_ESTIMATIVA_BODYSHOP;

    this.getEstimativaPorId();

    this.calcularSimulacao();
    this.somenteLeituraParaDelivery();
    this.carregarMargemContribuicao();
  }

  carregarMargemContribuicao() {
    this.loading = true;
    this.equipeService.getByPropostaId(this.estimativaId).subscribe({
      next: (result) => {
        this.margemLiquida = this.toPctNumber(
          result?.items?.[0]?.margemLiquida,
        );
      },
      complete: () => (this.loading = false),
    });
  }

  private getParamPct(nome: string): number {
    const p = this.params?.find(
      (x) => x.nome?.toLowerCase() === nome.toLowerCase(),
    );
    return p ? this.toPctNumber(p.valor) : 0;
  }

  private coletarPercentuais() {
    return {
      administrativo: this.getParamPct("Administrativo (%)"),
      bonificacao: this.getParamPct("Bonificação (%)"),
      impostos: this.getParamPct("Impostos (%)"),
      investimento: this.getParamPct("Investimento (%)"),
      margem: this.margemLiquida,
      lideranca: this.getParamPct("Liderança (%)"),
    };
  }

  private round2(v: number): number {
    return Number((v ?? 0).toFixed(2));
  }

  aplicarNoBodyShopESalvar() {
    if (this.somenteLeitura) return;

    this.loading = true;

    const pct = this.coletarPercentuais();
    const ch = this._changedParamNames().map((n) => this._normName(n));
    const preservePerEquipeMargin = ch.some(
      (s) => s.includes("lideranca") || s.includes("bonificacao"),
    );

    const somaSemMargem =
      pct.administrativo +
      pct.impostos +
      pct.bonificacao +
      pct.investimento +
      pct.lideranca;

    const usuarioId = this.utilService.getUserId();

    this.equipeService.getByPropostaId(this.estimativaId).subscribe({
      next: (res) => {
        const equipes: Equipe[] = res?.items ?? [];
        const updates = equipes.map((eq) => {
          const baseHora = Number(eq.baseHora) || 0;
          const custoHora = Number(
            eq.custoHora || this.priceResumo.custoHoraMedioSugerido || 0,
          );

          const margemAlvo = preservePerEquipeMargin
            ? Number(eq.margemLiquida) || 0
            : Number.isFinite(pct.margem)
              ? Number(pct.margem)
              : 0;

          const divisor = 1 - (somaSemMargem + margemAlvo) / 100;
          const precoHora = divisor > 0 ? this.round2(custoHora / divisor) : 0;
          const receitaBruta = this.round2(baseHora * precoHora);

          const payload: any = {
            profissional: null,
            composicaoEquipe: null,

            id: eq.id ?? 0,
            estimativaId: eq.estimativaId,

            margemLiquida: this.round2(margemAlvo),
            receitaBruta,
            precoHora,

            nome: eq.nome ?? eq.profissional?.cargo?.nome ?? null,

            baseHora,
            custoHora,

            encargoId: eq.profissional?.encargo?.id ?? eq.encargoId ?? null,
            cargoId: eq.profissional?.cargo?.id ?? eq.cargoId ?? null,
            contratoId: eq.profissional?.contrato?.id ?? eq.contratoId ?? null,
            profissionalId: eq.profissional?.id ?? eq.profissionalId ?? null,

            percentualLideranca: this.toNumber2(pct.lideranca),
            percentualBonificacao: this.toNumber2(pct.bonificacao),

            usuarioId,
          };

          return this.equipeService.update(payload);
        });

        if (!updates.length) {
          this.loading = false;
          this.toastr.mostrarMensagem(
            "aviso",
            "Atenção",
            "Nenhuma equipe encontrada para atualizar.",
          );
          return;
        }

        forkJoin(updates).subscribe({
          next: () => {
            this.toastr.mostrarMensagem(
              "sucesso",
              "Sucesso",
              preservePerEquipeMargin
                ? "Liderança/Bonificação aplicadas mantendo a Margem de cada recurso."
                : "Valores aplicados e salvos nas equipes.",
            );
          },
          error: (err) =>
            this.misc.processError(err, "Falha ao salvar as equipes."),
          complete: () => {
            this.loading = false;
          },
        });
      },
      error: (err) => {
        this.misc.processError(err, "Não foi possível carregar as equipes.");
        this.loading = false;
      },
    });
  }

  somenteLeituraParaDelivery() {
    if (this.isDelivery) {
      this.somenteLeitura = true;
    }
  }

  private toBoolish(v: any): boolean {
    return v === true || v === 1 || v === "1" || v === "true";
  }

  getEstimativaPorId() {
    this.priceParamProjetoService.getByEstimativa(this.estimativaId).subscribe(
      (params) => {
        this.params = params.items;
        this.paramsDefault = JSON.parse(JSON.stringify(this.params));

        const priceParamHoraCliente: PriceParamProjeto = this.params.find(
          (p) => p.priceParamId === 8,
        );
        this.exibeAdotado = priceParamHoraCliente
          ? Number(priceParamHoraCliente.valor) > 0
          : false;

        this.estimativaService
          .getById(this.estimativaId)
          .subscribe(
            (estimativa) => {
              if (estimativa.statusId !== 1) this.somenteLeitura = true;

              this.estimativaTipo = estimativa.estimativaTipoId;

              const rawFlag: any =
                (estimativa as any)?.bodyShopBonificacaoPorPerfil ??
                (estimativa as any)?.BodyShopBonificacaoPorPerfil ??
                (estimativa as any)?.bodyShopBonifPerfil ??
                (estimativa as any)?.BodyShopBonifPerfil ??
                0;

              this.bodyShopBonifPerfil = this.toBoolish(rawFlag);

              console.log("this.bodyShopBonifPerfil", this.bodyShopBonifPerfil);
              console.log("estimativa", estimativa);

              if (this.estimativaTipoId === this.estimativaProjeto) {
                this.tipoProjeto = true;
                this.tipoDelivery = false;
              }

              if (this.estimativaTipoId === this.estimativaDelivery) {
                this.tipoDelivery = true;
                this.tipoProjeto = false;
                this.carregarEstimativaRaiz();
              }

              const clienteId = Number(estimativa?.projeto?.clienteId) || 0;
              this.carregarMinimos(clienteId);

              this.carregar();
            },
            (error) =>
              this.misc.processError(
                error,
                "Não foi possível recuperar as informações da estimativa.",
              ),
          )
          .add(() => (this.loading = false));
      },
      (error) => {
        this.misc.processError(
          error,
          "Não foi possível recuperar os parâmetros da estimativa.",
        );
        this.loading = false;
      },
    );
  }

  calcularSimulacao() {
    this.calculoService.calcularSimulacao(this.estimativaId).subscribe(
      (result) => {
        this.priceSimulacao = result.objeto;
      },
      (error) => {
        this.misc.processError(error, "Não foi possível calcular o pricing.");
      },
    );
  }

  calcular() {
    if (this.somenteLeitura) {
      return;
    }

    this.loading = true;

    const priceParamHoraCliente: PriceParamProjeto = this.params.find(
      (p) => p.priceParamId === 8,
    );
    if (priceParamHoraCliente)
      this.exibeAdotado = Number(priceParamHoraCliente.valor) > 0;

    this.carregar();
  }

  carregar() {
    this.loading = true;

    this.priceModelService
      .getByEstimativaId(this.estimativaId, "receitaBrutaAdotado")
      .pipe(
        switchMap((priceModel) => {
          const receitaBrutaAdotado = priceModel ? priceModel.valor : 0;
          return this.calculoService.calcularPricing(
            this.estimativaId,
            receitaBrutaAdotado,
          );
        }),
        switchMap((result) => {
          this.priceResumo = result;
          this.adotado = result.valorHoraMedioVendaAdotado;
          this.sugerido = result.valorHoraMedioVendaSugerido;
          this.mostraAdotado = this.adotado === this.sugerido;

          return this.priceParamProjetoService.getByEstimativa(
            this.estimativaId,
          );
        }),
      )
      .subscribe({
        next: (paramsPage) => {
          this.params = paramsPage.items;
          this.paramsDefault = JSON.parse(JSON.stringify(this.params));

          const priceParamHoraCliente: PriceParamProjeto = this.params.find(
            (p) => p.priceParamId === 8,
          );
          this.exibeAdotado = priceParamHoraCliente
            ? Number(priceParamHoraCliente.valor) > 0
            : false;
        },
        error: (error) => {
          this.misc.processError(
            error,
            "Não foi possível calcular o pricing / recarregar parâmetros.",
          );
        },
        complete: () => (this.loading = false),
      });
  }

  carregarEstimativaIdForOriginalDupli() {
    this.priceModelService
      .getByEstimativaIdForOriginal(this.idOriginal)
      .subscribe({
        next: (res) => {
          this.idOriginalDupli = res.items?.[0]?.estimativaOriginalId;
          this.carregarEstimativaOriginalDupli(this.idOriginalDupli);
        },
      });
  }

  carregarEstimativaOriginalDupli(idOriginal: number) {
    this.calculoService.calcularPricing(this.idOriginalDupli, 0).subscribe({
      next: (result) => {
        this.priceOriginal = result;
        this.maoDeObraOriginal = result.maoDeObraDiretaAdotado;
      },
      error: (error) => {
        if (this.priceOriginal) {
          this.misc.processError(
            error,
            "Não foi possível buscar estimativa original.",
          );
        }
      },
    });
  }

  carregarEstimativaOriginal(idOriginal: number) {
    this.calculoService.calcularPricing(this.idOriginal, 0).subscribe({
      next: (result) => {
        this.priceOriginal = result;
        this.maoDeObraOriginal = result.maoDeObraDiretaAdotado;
      },
      error: (error) => {
        if (this.priceOriginal) {
          this.misc.processError(
            error,
            "Não foi possível buscar estimativa original.",
          );
        }
      },
    });
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(PriceEditarValorComponent, {
      width: "450px",
      data: {
        estimativaId: this.estimativaId,
        receitaBrutaSugerido: this.priceResumo.receitaBrutaSugerido,
      },
      panelClass: "default-dialog-container",
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.params[
          this.params.findIndex((x) => x.nome == "Provisão Risco (%)")
        ] = result;
        this.salvarParametro(result);
      }
    });
  }

  openDialogAdotado() {
    this.priceModelService
      .getByEstimativaId(this.estimativaId, "receitaBrutaAdotado")
      .subscribe((priceModel: any) => {
        const dialogRef = this.dialog.open(PriceEditaValorAdotadoComponent, {
          width: "450px",
          data: {
            estimativaId: this.estimativaId,
            receitaBrutaAdotado: this.priceResumo.receitaBrutaAdotado,
            priceModel: priceModel,
          },
          panelClass: "default-dialog-container",
        });

        dialogRef.afterClosed().subscribe((result) => {
          this.calcular();
        });
      });
  }

  salvarParametro(param: PriceParamProjeto) {
    const mudou = this._changedParamNames()
      .map((n) => this._normName(n))
      .includes(this._normName(param.nome));
    if (!mudou) return;

    const raw: unknown = (param as any)?.valor;
    if (this.isNilOrEmpty(raw)) {
      this.toastr.mostrarMensagem("aviso", "Atenção", "Valor do parâmetro não pode ser nulo.");
      this.params = JSON.parse(JSON.stringify(this.paramsDefault));
      return;
    }

    const n = this.toPctNumber((param as any)?.valor);
    if (!Number.isFinite(n)) {
      this.toastr.mostrarMensagem("aviso", "Atenção", "Valor do parâmetro inválido.");
      return;
    }

    if (this.isProvisaoRisco(param)) {
      // mantém todas as casas digitadas (ex.: 19,9999)
      param.valor = n;
    } else {
      // demais percentuais: fixa em 2 casas
      param.valor = Number((n ?? 0).toFixed(2));
    }

    this.loading = true;
    const usuarioId = this.utilService.getUserId();
    this.priceParamProjetoService.updateWithUsuario(param, usuarioId).subscribe({
      next: () => {
        this.toastr.mostrarMensagem("sucesso", "Sucesso!", "Parâmetro atualizado com sucesso.");
        this.paramsDefault = JSON.parse(JSON.stringify(this.params));
        this.calcular();
      },
      error: (error) => {
        this.misc.processError(error, "Não foi possível atualizar o parâmetro.");
        this.loading = false;
      },
    });
  }

  atualizarPricingFromStaffPlan(event: any) {
    var estimativaId = this.activatedRouter.snapshot.params.id;

    this.estimativaService
      .getById(Number(estimativaId))
      .subscribe((estimativa) => {
        estimativa.pricingFromStaffPlan = event;

        this.estimativaService.update(estimativa).subscribe(() => { });
      });
  }

  async carregarEstimativaRaiz() {
    let idAtual = this.estimativaId;

    try {
      while (true) {
        const res = await this.priceModelService
          .getByEstimativaIdForOriginal(idAtual)
          .toPromise();
        const item = res?.items?.[0];

        if (!item) {
          console.warn("Não foi encontrado original para", idAtual);
          return;
        }

        const tipoEstimativaOriginal =
          item.estimativaOriginal?.estimativaTipoId;
        const idOriginal = item.estimativaOriginalId;

        if (
          tipoEstimativaOriginal ===
          constants.TipoEstimativaConstants.ID_TIPO_ESTIMATIVA_PROJETO
        ) {
          this.idOriginal = idOriginal;

          await this.carregarEstimativaOriginal(this.idOriginal);
          this.recalcularTotais();
          break;
        } else {
          idAtual = idOriginal;
        }
      }
    } catch (error) {
      console.error("Erro ao buscar raiz da estimativa:", error);
    }
  }

  recalcularTotais() {
    const v = this.valoresDigitados;
    const r = this.priceResumo ?? ({} as PriceResumo);
    const o = this.priceOriginal ?? ({} as PriceResumo);

    // Mão de Obra Direta
    this.totais.maoDeObraDireta =
      v.maoDeObraDireta > 0
        ? v.maoDeObraDireta + (r.maoDeObraDiretaSugerido || 0)
        : null;
    this.percentuais.maoDeObraDireta = this.totais.maoDeObraDireta
      ? this.calcPct(o.maoDeObraDiretaAdotado, this.totais.maoDeObraDireta)
      : null;

    // Parceiros
    this.totais.parceiros =
      v.parceiros > 0
        ? v.parceiros + (r.somaTotalCustoParceiroSugerido || 0)
        : null;
    this.percentuais.parceiros = this.totais.parceiros
      ? this.calcPct(o.somaTotalCustoParceiroAdotado, this.totais.parceiros)
      : null;

    // Custos Adicionais
    this.totais.custosAdicionais =
      v.custosAdicionais > 0
        ? v.custosAdicionais + (r.custosAdicionaisSugerido || 0)
        : null;
    this.percentuais.custosAdicionais = this.totais.custosAdicionais
      ? this.calcPct(o.custosAdicionaisAdotado, this.totais.custosAdicionais)
      : null;

    // Qtde. de Horas (inteiro)
    const horasDigitadas = Math.floor(v.quantidadeHoras || 0);
    this.totais.quantidadeHoras =
      horasDigitadas > 0
        ? horasDigitadas + (r.quantidadeHorasSugerido || 0)
        : null;
    this.percentuais.quantidadeHoras = this.totais.quantidadeHoras
      ? this.calcPct(o.quantidadeHorasAdotado, this.totais.quantidadeHoras)
      : null;

    // Custo Hora Médio
    this.totais.custoHoraMedio =
      v.custoHoraMedio > 0
        ? v.custoHoraMedio + (r.custoHoraMedioSugerido || 0)
        : null;
    this.percentuais.custoHoraMedio = this.totais.custoHoraMedio
      ? this.calcPct(o.custoHoraMedioAdotado, this.totais.custoHoraMedio)
      : null;
  }

  private calcPct(original: number, total: number): number {
    return total > 0 ? ((original - total) / total) * 100 : 0;
  }

  get paramsOrdenados(): any[] {
    return (
      this.params?.slice().sort((a, b) => {
        if (a.nome === "Liderança (%)") return -1;
        if (b.nome === "Liderança (%)") return 1;
        return 0;
      }) || []
    );
  }

  private alvosPorTipo(): number[] {
    const tipo = this.estimativaTipo || this.estimativaTipoId;

    if (tipo === 1) {
      return [this.PROJ.BONIFICACAO, this.PROJ.MARGEM, this.PROJ.LIDERANCA];
    }
    if (tipo === 2) {
      return [this.BS.BONIFICACAO, this.BS.LIDERANCA];
    }
    return [];
  }

  private carregarMinimos(clienteId: number): void {
    const idsAlvo = this.alvosPorTipo();
    if (!idsAlvo.length) return;

    this.priceParamService.getByClienteId(clienteId).subscribe({
      next: (resCliente) => {
        const itensCliente = (resCliente?.items || []).filter(
          (x: any) => x?.ativo,
        );

        itensCliente
          .filter((x: any) => idsAlvo.includes(Number(x.priceParamId)))
          .forEach(
            (x: any) =>
              (this.minPct[Number(x.priceParamId)] = this.toPctNumber(x.valor)),
          );

        const tipo = this.estimativaTipo || this.estimativaTipoId;
        itensCliente.forEach((x: any) => {
          const nome = this.norm(x?.nome);
          const valor = this.toPctNumber(x?.valor);
          if (!nome) return;

          if (tipo === 1) {
            // PROJETO
            if (nome.includes("bonificacao"))
              this.minPct[this.PROJ.BONIFICACAO] = valor;
            if (nome.includes("margem")) this.minPct[this.PROJ.MARGEM] = valor;
            if (nome.includes("lideranca"))
              this.minPct[this.PROJ.LIDERANCA] = valor;
          } else if (tipo === 2) {
            // BODYSHOP
            if (nome.includes("bonificacao"))
              this.minPct[this.BS.BONIFICACAO] = valor;
            if (nome.includes("lideranca"))
              this.minPct[this.BS.LIDERANCA] = valor;
          }
        });

        const faltando = idsAlvo.filter((id) => this.minPct[id] == null);
        if (faltando.length) this.carregarMinimosPadrao(idsAlvo);
      },
      error: () => this.carregarMinimosPadrao(idsAlvo),
    });
  }

  tipoParam(): string {
    const tipo = this.estimativaTipo || this.estimativaTipoId;
    if (tipo === 1) {
      return "P";
    }
    if (tipo === 2) {
      return "BS";
    }
  }

  private carregarMinimosPadrao(idsAlvo: number[]): void {
    this.priceParamService.getByTipo(this.tipoParam()).subscribe({
      next: (resPadrao) => {
        const itens = (resPadrao?.items || []).filter((x: any) => x?.ativo);

        const tipo = this.estimativaTipo || this.estimativaTipoId;

        itens.forEach((x: any) => {
          const rawId = Number(x.priceParamId ?? x.id);
          const nome = this.norm(x?.nome);
          const valor = this.toPctNumber(x?.valor);

          if (tipo === 1) {
            // PROJETO
            if (rawId === this.PROJ.BONIFICACAO || nome.includes("bonificacao"))
              this.minPct[this.PROJ.BONIFICACAO] = valor;
            if (rawId === this.PROJ.MARGEM || nome.includes("margem"))
              this.minPct[this.PROJ.MARGEM] = valor;
            if (rawId === this.PROJ.LIDERANCA || nome.includes("lideranca"))
              this.minPct[this.PROJ.LIDERANCA] = valor;
          } else if (tipo === 2) {
            // BODYSHOP
            if (rawId === this.BS.BONIFICACAO || nome.includes("bonificacao"))
              this.minPct[this.BS.BONIFICACAO] = valor;
            if (rawId === this.BS.LIDERANCA || nome.includes("lideranca"))
              this.minPct[this.BS.LIDERANCA] = valor;
          }
        });
      },
      error: (err) =>
        this.misc.processError(err, "Falha ao carregar mínimos padrão."),
    });
  }

  private getValorAtual(item: PriceParamProjeto): number {
    if (item.priceParamId === this.PROJ.MARGEM) {
      const vInput = this.toPctNumber(item?.valor);
      if (vInput > 0) return vInput;
      return this.toPctNumber(this.margemLiquida);
    }
    return this.toPctNumber(item?.valor);
  }

  isVigiado(item: PriceParamProjeto): boolean {
    const key = this.keyFor(item);
    return key != null && this.alvosPorTipo().includes(key);
  }

  isBelowMin(item: PriceParamProjeto): boolean {
    const key = this.keyFor(item);
    if (key == null) return false;
    const min = this.minPct[key];
    if (min == null) return false;

    return this.getValorAtual(item) < min;
  }

  getMinTooltip(item: PriceParamProjeto): string {
    const key = this.keyFor(item);
    const min = key != null ? (this.minPct[key] ?? 0) : 0;
    const atual = this.getValorAtual(item);
    const nome = item?.nome || 'Parâmetro';

    return `${nome}: percentual atual (${this.fmtPctForItem(item, atual)}%) está abaixo do mínimo (${this.fmtPctForItem(item, min)}%).`;
  }

  private toPctNumber(v: any): number {
    if (v === null || v === undefined) return 0;
    if (typeof v === "number") return isFinite(v) ? v : 0;
    if (typeof v === "string") {
      const s = v.replace(/\./g, "").replace(",", ".").trim();
      const n = parseFloat(s);
      return isNaN(n) ? 0 : n;
    }
    const n = Number(v);
    return isNaN(n) ? 0 : n;
  }

  private norm(s: any): string {
    return (s ?? "")
      .toString()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase()
      .trim();
  }

  keyFor(item: PriceParamProjeto): number | null {
    const tipo = this.estimativaTipo || this.estimativaTipoId;
    const pid = Number(item?.priceParamId);
    const nome = this.norm(item?.nome);

    if (tipo === 1) {
      // PROJETO
      if (pid === this.PROJ.BONIFICACAO || nome.includes("bonificacao"))
        return this.PROJ.BONIFICACAO;
      if (pid === this.PROJ.MARGEM || nome.includes("margem"))
        return this.PROJ.MARGEM;
      if (pid === this.PROJ.LIDERANCA || nome.includes("lideranca"))
        return this.PROJ.LIDERANCA;
    } else if (tipo === 2) {
      // BODYSHOP
      if (pid === this.BS.BONIFICACAO || nome.includes("bonificacao"))
        return this.BS.BONIFICACAO;
      if (pid === this.BS.LIDERANCA || nome.includes("lideranca"))
        return this.BS.LIDERANCA;
    }
    return null;
  }

  private _normName(s?: string): string {
    return (s ?? "")
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase()
      .trim();
  }

  private _changedParamNames(): string[] {
    const changed: string[] = [];
    const byName = new Map<string, PriceParamProjeto>();
    (this.paramsDefault ?? []).forEach((p) =>
      byName.set(this._normName(p.nome), p),
    );

    (this.params ?? []).forEach((p) => {
      const key = this._normName(p.nome);
      const before = byName.get(key);
      if (!before) return;
      const vBefore = this.toPctNumber(before.valor);
      const vNow = this.toPctNumber(p.valor);
      if (
        Number.isFinite(vBefore) &&
        Number.isFinite(vNow) &&
        vBefore !== vNow
      ) {
        changed.push(p.nome);
      }
    });
    return changed;
  }

  private toNumber2(n: number): number {
    return Number((n ?? 0).toFixed(2));
  }

  private isNilOrEmpty(v: unknown): boolean {
    return v == null || (typeof v === "string" && v.trim() === "");
  }

  pct2num(valor?: number, receita?: number): number | null {
    const v = Number(valor ?? 0);
    const r = Number(receita ?? 0);
    if (!Number.isFinite(v) || !Number.isFinite(r) || r <= 0) return null;
    return Math.round((v * 10000) / r) / 100;
  }

  trackParam = (_: number, p: PriceParamProjeto) =>
    p?.id ?? p?.priceParamId ?? this._normName(p?.nome);

  isChanged(item: PriceParamProjeto): boolean {
    const before = (this.paramsDefault || []).find(
      (p) => this._normName(p.nome) === this._normName(item.nome),
    );
    if (!before) return false;
    return this.toPctNumber(before.valor) !== this.toPctNumber(item.valor);
  }

  toPtBR(n: any): string {
    const v = Number(n ?? 0);
    return isFinite(v) ? v.toString().replace('.', ',') : '0,00';
  }

  //funcoes para mudar percentual aceitar mais casas decimais
  normalizarPercentual(item: any) {
    if (this.isProvisaoRisco(item)) return;
    const n = this.toPctNumber(item?.valor);
    if (Number.isFinite(n)) item.valor = Number(n.toFixed(2));
  }

  isProvisaoRisco(p: any): boolean {
    const n = (p?.nome || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase();
    return n.includes('provisao') && n.includes('risco');
  }

  onFreePctChange(p: any, txt: string) {
    p.__raw = (txt ?? '').replace(/[^\d\.,]/g, '');
  }

  onFreePctBlur(p: any) {
    const raw = (p.__raw ?? '').trim();
    const norm = raw.replace(/\./g, '').replace(',', '.');
    const n = Number(norm);
    p.valor = Number.isFinite(n) ? n : 0;
    delete p.__raw;

    this.salvarParametro(p);
    this.aplicarNoBodyShopESalvar();
  }

  private fmtPctForItem(item: PriceParamProjeto, n: number): string {
    const isProv = this.isProvisaoRisco(item);
    const v = Number.isFinite(n) ? n : 0;
    return v.toLocaleString('pt-BR', {
      minimumFractionDigits: isProv ? 0 : 2,
      maximumFractionDigits: isProv ? 8 : 2,
    });
  }

  private buildMask(raw: string, padFrac: boolean): { mask: string; num: number } {
    const txt = (raw ?? '').replace(/\./g, '');
    const hasComma = txt.includes(',');

    let intDigits = '';
    let fracDigits = '';

    if (hasComma) {
      const [left, right] = txt.split(',', 2);
      intDigits = (left ?? '').replace(/\D/g, '').slice(0, 2);
      fracDigits = (right ?? '').replace(/\D/g, '');
    } else {
      const ds = txt.replace(/\D/g, '');

      if (!padFrac) {
        if (ds.length <= 3) {
          intDigits = ds;
          fracDigits = '';
        } else {
          intDigits = ds.slice(0, 2);
          fracDigits = ds.slice(2);
        }
      } else {
        if (ds.length <= 2) {
          intDigits = ds;
          fracDigits = '';
        } else if (ds.length === 3) {
          intDigits = ds.slice(0, 1);
          fracDigits = ds.slice(1);
        } else {
          intDigits = ds.slice(0, 2);
          fracDigits = ds.slice(2);
        }
      }
    }

    intDigits = intDigits.replace(/\D/g, '').slice(0, 2);
    fracDigits = fracDigits.replace(/\D/g, '').slice(0, 9);

    if (padFrac) {
      if (!fracDigits) {
        fracDigits = '00';
      } else if (fracDigits.length < 2) {
        fracDigits = fracDigits.padEnd(2, '0');
      }
    }

    const mask = fracDigits
      ? `${intDigits || '0'},${fracDigits}`
      : (intDigits || '');

    const iNum = Number(intDigits || '0');
    const num = Number(`${iNum}.${fracDigits || '0'}`);

    return { mask, num: Number.isFinite(num) ? num : 0 };
  }

  onProvFocus(p: any, ev?: FocusEvent) {
    p.__origVal = p.valor;
    p.__origMask = p.__mask ?? this.formatProvFromNumber(p.valor);
    p.__edited = false;

    const el = ev?.target as HTMLInputElement;
    if (el) setTimeout(() => { try { el.setSelectionRange(0, el.value.length); } catch { } }, 0);
  }

  onProvInput(p: any, txt: string) {
    p.__edited = true;
    const { mask } = this.buildMask(txt ?? '', false);
    p.__mask = mask;
  }

  onProvBlur(p: any) {
    if (!p.__edited) {
      p.__mask = p.__origMask;
      p.valor = p.__origVal;
      delete p.__origMask; delete p.__origVal; delete p.__edited;
      return;
    }

    const { mask, num } = this.buildMask(p.__mask ?? '', true);
    p.__mask = mask || '0,00';
    p.valor = num;

    delete p.__origMask; delete p.__origVal; delete p.__edited;

    this.salvarParametro(p);
    this.aplicarNoBodyShopESalvar();
  }

  formatProvFromNumber(n: any): string {
    if (n == null || n === '') return '0,00';
    const s = String(n).replace(/\./g, ',');
    return this.buildMask(s, true).mask || '0,00';
  }

  onMaskProvBlur(p: any) {
    const m = String(p.__mask ?? '00,00');
    const n = Number(m.replace(/\./g, '').replace(',', '.'));
    p.valor = Number.isFinite(n) ? n : 0;

    p.__mask = this.formatProvFromNumber(p.valor);

    this.salvarParametro(p);
    this.aplicarNoBodyShopESalvar();
  }
}
